const gridTheme = {
  row: {
    padding: 10,
  },
  col: {
    padding: 10,
  },
  container: {
    padding: 15,
    breakpoints: {
      xxl: 1400,
    },
    maxWidth: {
      sm: 570,
      md: 758,
      lg: 1014,
      xl: 1430, // TODO: update once styled-bootstrap-grid supports xxl breakpoint
      xxl: 1430,
    },
  },
}

export default gridTheme
